import React from 'react';
import { SectionHeading } from './SectionHeading';
import { VALUE_ROWS } from '../data/content';
export function ValueTable() {
  return <section className="py-10 sm:py-12" style={{
    paddingTop: "1px",
    paddingBottom: "0px"
  }} data-id="element-206" data-mp="i9mp5q46crin">
      <div className="mx-auto max-w-content px-5" style={{
      paddingTop: "48px"
    }} data-id="element-207" data-mp="3cc6nwt46ldf">
        <SectionHeading title="Everything that’s" highlight="yours today" data-id="element-208" data-mp="8ax79xca372e" />

        <p className="mt-4 text-center text-xs font-semibold uppercase tracking-wide text-white/35 md:hidden" data-id="element-209" data-mp="vywzl1p8n5j3">
          ← Scroll to see full table →
        </p>

        <div className="hide-scrollbar mx-auto mt-3 max-w-3xl overflow-x-auto rounded-2xl border border-ink-700" data-id="element-210" data-mp="110mdqq7rbzbe">
          <table className="w-full min-w-[420px] border-collapse text-left" data-id="element-211" data-mp="r8qa6zmwjgzs">
            <caption className="sr-only" data-id="element-212" data-mp="r6nafnvy69hv">What is included and its value</caption>
            <thead data-id="element-213" data-mp="1ewrhk58cgrdm">
              <tr className="bg-ink-800" data-id="element-214" data-mp="1ew7z8nes80z2">
                <th className="px-5 py-2.5 text-xs font-extrabold uppercase tracking-[0.15em] text-white/60" data-id="element-215" data-mp="1jparms7tp4do">
                  What’s included
                </th>
                <th className="px-5 py-2.5 text-right text-xs font-extrabold uppercase tracking-[0.15em] text-white/60" data-id="element-216" data-mp="33lz3p7j3uyhm">
                  Value
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-ink-700 bg-ink-850" data-id="element-217" data-mp="38nelmqpzkovs">
              {VALUE_ROWS.map(row => <tr key={row.item} data-id="element-218" data-mp="38ljyd5r8skoj">
                  <td className="px-5 py-2.5 text-sm font-semibold text-white/85" data-id="element-219" data-mp="3me08eqik9iyy">{row.item}</td>
                  <td className="px-5 py-2.5 text-right text-sm font-extrabold" data-id="element-220" data-mp="3hghvyq5c4lm7">
                    <span className={row.free ? 'text-lime-400' : 'text-white/60'} data-id="element-221" data-mp="7bf4oam1691">
                      {row.value}
                    </span>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="mx-auto mt-4 flex max-w-3xl flex-col items-center gap-0.5 text-center" data-id="element-222" data-mp="21zr7fbaoyyg9">
          <p className="text-sm font-bold text-white/70" data-id="element-223" data-mp="1x0wnu74wh5v3">
            Total value: <s className="text-white/40" data-id="element-224" data-mp="2moim7q57q1vw">USD 193</s>
          </p>
          <p className="text-base font-extrabold text-lime-400 sm:text-lg" data-id="element-225" data-mp="2mq3eta7yvar4">
            Your savings: USD 166 off (86% OFF)
          </p>
        </div>
      </div>
    </section>;
}